/* eslint-disable no-undef */
import ApiService , {callCustomMethodAsync} from '../service/ApiService';

let moduleApi = {};
let moduleName = "draff_document_auto";

moduleApi.create = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id,loading) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id},
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id,loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id},
    dontLoading: (loading == undefined ? false : loading ),
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.CopyTextEditor = async (id) => {
  let api = {
    module: moduleName,
    body: {
      id: id
    },
    type: "CopyTextEditor",
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.SignForApproval = async (id) => {
  let api = {
    module: moduleName,
    body: {
      dda_id: id
    },
    type: "SignForApproval",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.SignForReject = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SignForReject",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.CheckCode = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "CheckCode",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.ViewSignOnPdf = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "ViewSignOnPdf",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.ViewSignsOnPdf = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "ViewSignsOnPdf",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.ViewDraffPdf = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "ViewDraffPdf",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.requestForSign = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "requestForSign",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

export default moduleApi;
